// 详情页的用户信息
import { defineStore } from "pinia";
import { login, loginInfo } from "@/api/index";
import { getToken, setToken } from "../utils/auth";

export const userInfoStore = defineStore({
    id: 'myUserInfoStore',
    state: () => ({
        userInfo: {
            username: "",
            roles: [],
            name: "",
            mobile: 0,
            id: '',
            locations: "",
            dutyName: "",
            tokenValue: "",
            clientId: "",
            dutyCode: "",
        }
    }),

    actions: {
        user_login(form) {
            const loginForm = {
                ...form,
                grant_type: 'password',
                client_id: 'web',
                client_secret: '123456'
            }
            return new Promise((resolve, reject) => {
                const formData = new FormData()
                for (const i in loginForm) formData.append(i, loginForm[i])
                login(formData).then(res => {
                    setToken(res.value)
                    resolve()
                }).catch(_ => {
                    reject()
                })
            })
        },

        setUserInfo(info) {
            for(let i in this.userInfo) {
                for(let j in info) {
                    if(i == j) this.userInfo[i] = info[j]
                }
            }
        },
        getUserInfo() {
            return new Promise((resolve, reject) => {
                loginInfo({ token: getToken() }).then(res => {
                    this.setUserInfo(res)
                    resolve()
                 }).catch(err => reject(err));
            })
            
        }
    }
})